<template>
  <e-dialog
      dialogTitle="业务咨询人"
      :centerDialogVisible="visible"
      @resetPopupData="resetPopupData"
      :showCloseBtn="true"
      :showBtn="false"
      :popupWidth="'580px'">
    <e-table-list
        maxHeight="400"
        :table-data="list"
        :table-label="tableLabel">
    </e-table-list>
  </e-dialog>
</template>

<script>
  import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
  import eTableList from '@/modules/projectA/components/common/e-table-list';

  export default {
    name: 'personnelInfo',
    components: { eDialog, eTableList },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      //业务咨询人
      list: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        tableLabel: [
          {
            label: '业务咨询人',
            param: 'businessConsultName',
            align: 'center',
            minWidth: 110
          },
          {
            label: '电话',
            param: 'businessConsultTel',
            align: 'center',
            minWidth: 140
          },
          {
            label: '邮箱',
            param: 'businessConsultEmail',
            align: 'center',
            minWidth: 110,
            tooltip: true
          }
        ]
      };
    },
    methods: {
      resetPopupData() {
        this.$emit('update:visible', false);
      }
    }
  };
</script>
